import { Paper, Skeleton, Typography } from "@mui/material";
import useSWR from "swr";
import { fetchData } from "../../../../lib/dashboard/data";
import GlobalTable from "./GlobalTable";

const Domestic = () => {
  const inc = useSWR(
    "/dashboard/global-top-price-change?price_changes=inc",
    fetchData
  );

  const dec = useSWR(
    "/dashboard/global-top-price-change?price_changes=dec",
    fetchData
  );
  const isLoading = inc.isLoading || dec.isLoading;

  return (
    <Paper sx={{ height: 505 }}>
      {isLoading ? <Skeleton variant='rounded' height={"100%"} /> :
        <>
          <Typography sx={{ mb: 2, fontWeight: 700 }}>بازار جهانی </Typography>
          <GlobalTable incData={inc.data || []} decData={dec.data || []} />
        </>
      }
    </Paper>
  );
};

export default Domestic;
